import { EmployeeDetail } from '@dap/memberadmin/types';

export function getIfMultipleEmployments(employee: EmployeeDetail): boolean {
  return (
    (employee.brands && employee.brands?.length > 1) ||
    (employee.dataowners && employee.dataowners.length > 1) ||
    (employee.locations && employee.locations.length > 1) ||
    false
  );
}
